/**
 * @param {*} data : response from get order api
 * @returns Array of objects as required by order table
 */
export const convertOrderList = (data) => {
  const list = data?.orders || [];
  return list.map((item) => {
    return {
      key: item.ordergroupid,
      groupId: item.ordergroupid,
      providerId: item.providerid,
      groupName: item.groupname,
      itemNumber: item.itemnumber,
      poNumber: item.ponumber,
      poLine: item.poline,
      manufacturer: item.manufacturer,
      modelName: item.modelname,
      providerName: item.providername,
      quantity: item.quantity,
      orderStatus: item.orderstatus,
      receivedStatus: item.receivedstatus,
      receivedDate: item.receiveddate,
      createBy: item.createby,
      createDate: item.createdate,
      highjumpDate: item.highjumpdate,
    };
  });
};

/**
 * @param {*} data : response from get order metrics api
 * @returns formatted order metrics object
 */
export const convertOrderCount = (data) => {
  const obj = data?.ordermetrics || {};
  return {
    totalOrders: obj.totalorders,
    receivedOrders: obj.receivedorders,
    newOrders: obj.neworders,
  };
};
